(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["d-clinical-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      for (const root of document.querySelectorAll('.d-clin2')) {
        // As in d-clinical: references start closed on phones.
        if (window.innerWidth < 750) root.querySelector('.d-clin2__accordion[open]')?.removeAttribute('open');

        const track = root.querySelector('[data-clin2-track]');
        const dots = [...root.querySelectorAll('[data-clin2-dot]')];
        if (!track || !dots.length) continue;
        const cards = [...track.querySelectorAll('[data-clin2-card]')];

        const closest = () => {
          const center = track.scrollLeft + track.clientWidth / 2;
          let best = 0;
          cards.forEach((card, i) => {
            const d = (c) => Math.abs(c.offsetLeft + c.offsetWidth / 2 - center);
            if (d(card) < d(cards[best])) best = i;
          });
          return best;
        };

        let ticking = false;
        track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const active = closest();
            dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
            ticking = false;
          });
        });

        dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            if (cards[i]) track.scrollTo({ left: cards[i].offsetLeft, behavior: 'smooth' });
          });
        });
      }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-edge-blur-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // "Top strip only after scrolling": an 8px marker at the very top of the page; while it is on screen the strip hides.
    const init = (scope) => {
      scope.querySelectorAll('.edge-blur--top[data-after-scroll]').forEach((strip) => {
        if (strip.dataset.edgeReady) return;
        strip.dataset.edgeReady = '1';
        let marker = document.getElementById('edge-blur-top-marker');
        if (!marker) {
          marker = document.createElement('div');
          marker.id = 'edge-blur-top-marker';
          marker.setAttribute('aria-hidden', 'true');
          marker.style.cssText = 'display:block;position:absolute;top:0;left:0;width:1px;height:8px;pointer-events:none'; // Dawn hides empty divs
          document.body.prepend(marker);
        }
        new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) strip.dataset.hidden = '';
          else delete strip.dataset.hidden;
        }).observe(marker);
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-featured-in-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // A logo shows its quote and image; arrow keys move between logos, Home / End to the first / last.
    const select = (card, i, focus) => {
      card.querySelectorAll('[data-fin-tab]').forEach((tab) => {
        const on = Number(tab.dataset.finTab) === i;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      card.querySelectorAll('[data-fin-panel]').forEach((panel) => { panel.hidden = Number(panel.dataset.finPanel) !== i; });
    };

    // Each quote block brings its own tab and image: the tabs go into the logo row, the images into the image column
    // (a quote without one shows the first quote's image, so the layout never jumps).
    const init = (card) => {
      if (card.dataset.finReady) return;
      const items = [...card.querySelectorAll('[data-fin-item]')];
      const track = card.querySelector('[data-fin-track]');
      const media = card.querySelector('[data-fin-media]');
      const first = card.querySelector('[data-fin-item] [data-fin-img]');
      items.forEach((item, i) => {
        const tab = item.querySelector('[data-fin-tab]');
        const img = item.querySelector('[data-fin-img]') || (first && first.cloneNode(true));
        item.querySelector('[data-fin-panel]').dataset.finPanel = i;
        if (tab) {
          tab.dataset.finTab = i;
          track.append(tab);
        }
        if (img) {
          img.dataset.finPanel = i;
          media.append(img);
        }
      });
      select(card, 0, false);
      card.dataset.finReady = '1';
      card.addEventListener('click', (e) => {
        const tab = e.target.closest('[data-fin-tab]');
        if (tab) select(card, Number(tab.dataset.finTab), false);
      });
      card.addEventListener('keydown', (e) => {
        const tab = e.target.closest('[data-fin-tab]');
        if (!tab) return;
        const n = items.length;
        const at = Number(tab.dataset.finTab);
        const to = { ArrowRight: at + 1, ArrowLeft: at - 1, Home: 0, End: n - 1 }[e.key];
        if (to === undefined) return;
        e.preventDefault();
        select(card, (to + n) % n, true);
      });
    };

    const all = (target) => [...(target.matches?.('[data-fin]') ? [target] : target.querySelectorAll('[data-fin]'))];
    document.querySelectorAll('[data-fin]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => all(e.target).forEach(init));
    // The editor selects a quote block: show it
    document.addEventListener('shopify:block:select', (e) => {
      const item = e.target.closest('[data-fin-item]');
      const card = e.target.closest('[data-fin]');
      if (item && card) select(card, [...card.querySelectorAll('[data-fin-item]')].indexOf(item), false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-footer-v2"] && !Shopify.designMode) return;
  try {
    
  // Phones: a column heading opens and closes its links. One listener for every footer, so it works at any width,
  // after a resize or rotation, and after the editor reloads the section.
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.d-footer-v2__toggle');
    if (!toggle || matchMedia('(min-width: 992px)').matches) return;
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    toggle.closest('.d-footer-v2__column').toggleAttribute('data-open', open);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-header-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Binds only this section's d-header-v2__ hooks, per header: the old header's script binds by d-header__ classes
    // page-wide, so the two never meet when both are on one page. The cart link and the localization form keep their
    // d-header__ markup for cart-drawer.js, jvt-atc-cart-icon and the language snippet; this script leaves them alone.
    const lockScroll = (on) => { document.body.style.overflow = on ? 'hidden' : ''; };

    const openSearch = (root) => {
      const modal = root.querySelector('.header__search');
      const details = modal && modal.querySelector('details');
      if (!details) return;
      modal.style.display = 'block';
      details.open = true;
      setTimeout(() => {
        const input = modal.querySelector('input[type="search"]');
        if (input) input.focus();
      }, 100);
    };

    // Free-shipping line. The threshold comes from ONE place, getFreeShippingThreshold: for now the section's
    // placeholder setting; swap its body for the side cart app's value when that is wired in (owner, 29 Oct).
    const getFreeShippingThreshold = (el) => Number(el.dataset.freeThreshold) || 0;

    const freeShippingState = (cart, thresholdCents, freeIds) => {
      if (!cart || !cart.item_count) return { state: 'empty', remaining: thresholdCents };
      const remaining = Math.max(0, thresholdCents - cart.total_price);
      const freeItem = (cart.items || []).some((item) => freeIds.includes(item.product_id));
      return { state: freeItem || remaining === 0 ? 'unlocked' : 'below', remaining };
    };

    // Amounts in the shopper's currency, formatted like Liquid's money filters: the section renders {{ 100 | money }}
    // ("€1,00", "£1.00") and the symbol and decimal separator are reused; whole amounts drop ",00" like
    // money_without_trailing_zeros on page load.
    const money = (el, cents) => {
      const sample = el.dataset.moneySample || '1.00';
      const match = sample.match(/1([.,])00/);
      const separator = match ? match[1] : '.';
      const amount = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2).replace('.', separator);
      return match ? sample.replace(match[0], amount) : amount;
    };

    const renderFreeShipping = (el, cart) => {
      const threshold = getFreeShippingThreshold(el);
      const { state, remaining } = freeShippingState(cart, threshold, window.jvtFreeShippingProductIds || []);
      el.dataset.state = state;
      el.querySelectorAll('[data-free-text]').forEach((text) => { text.hidden = text.dataset.freeText !== state; });
      el.querySelectorAll('[data-free-amount="threshold"]').forEach((amount) => { amount.textContent = money(el, threshold); });
      el.querySelectorAll('[data-free-amount="remaining"]').forEach((amount) => { amount.textContent = money(el, remaining); });
    };

    // After any cart change: Dawn's cart-update event, and the count changing (cart apps that skip Dawn's event
    // still update #cart-icon-bubble). Reads /cart.js rather than trusting an event's payload.
    const watchFreeShipping = (root) => {
      const el = root.querySelector('.d-header-v2__free[data-free-threshold]');
      if (!el) return;
      let timer;
      const refresh = () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          const url = `${(window.routes && window.routes.cart_url) || '/cart'}.js`;
          fetch(url, { headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .then((cart) => renderFreeShipping(el, cart))
            .catch(() => {});
        }, 150);
      };
      const hook = () => {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook, { once: true });
      else hook();
      const bubble = root.querySelector('#cart-icon-bubble');
      if (bubble && 'MutationObserver' in window) new MutationObserver(refresh).observe(bubble, { childList: true, subtree: true, characterData: true });
      // The side cart app (UpCart) and other cart apps: their subscribe hooks (the app loads after the theme, so keep
      // trying for ~10s) and document events — the same ones snippets/jvt-atc-cart-icon.liquid listens to.
      const bindUpcart = () => {
        if (el.dataset.upcartBound) return true;
        const subscribeCart = window.upcartSubscribeCartUpdated || window.upcartSubscribeCartChanged;
        if (typeof subscribeCart !== 'function') return false;
        el.dataset.upcartBound = '1';
        subscribeCart(refresh);
        return true;
      };
      if (!bindUpcart()) {
        let tries = 0;
        const timer = setInterval(() => { if (bindUpcart() || ++tries > 40) clearInterval(timer); }, 250);
      }
      ['cart:updated', 'theme:cart:change', 'upcart:cart:updated', 'ajaxCart:updated'].forEach((name) => document.addEventListener(name, refresh));
    };

    const initHeaderV2 = (root) => {
      if (root.dataset.headerV2Ready) return;
      root.dataset.headerV2Ready = '1';

      watchFreeShipping(root);

      const searchButton = root.querySelector('.d-header-v2__search-button');
      if (searchButton) searchButton.addEventListener('click', (e) => { e.preventDefault(); openSearch(root); });

      // Desktop dropdowns: a click toggles, a click outside any dropdown closes them
      const items = [...root.querySelectorAll('.d-header-v2__menu-item--has-dropdown')];
      items.forEach((item) => {
        const link = item.querySelector('.d-header-v2__menu-link');
        if (!link) return;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          items.forEach((other) => { if (other !== item) other.classList.remove('is-open'); });
          item.classList.toggle('is-open');
        });
      });
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.d-header-v2__menu-item--has-dropdown')) items.forEach((item) => item.classList.remove('is-open'));
      });

      // Mobile drawer: the menu button opens and closes it, the body stops scrolling while it is open
      const drawer = root.querySelector('.d-header-v2__drawer');
      const menuButton = root.querySelector('.d-header-v2__menu-button');
      const iconOpen = root.querySelector('.d-header-v2__menu-icon-open');
      const iconClose = root.querySelector('.d-header-v2__menu-icon-close');
      const setIcon = (open) => {
        if (iconOpen) iconOpen.style.display = open ? 'none' : 'block';
        if (iconClose) iconClose.style.display = open ? 'block' : 'none';
      };
      const setDrawer = (open) => { drawer.open = open; setIcon(open); lockScroll(open); };
      if (drawer && menuButton) {
        menuButton.addEventListener('click', (e) => { e.preventDefault(); setDrawer(!drawer.open); });
        const close = root.querySelector('.d-header-v2__drawer-close');
        if (close) close.addEventListener('click', (e) => { e.preventDefault(); setDrawer(false); });
        drawer.addEventListener('toggle', () => { if (!drawer.open) { setIcon(false); lockScroll(false); } });
      }

      // Mobile search lives in the drawer: close the menu, open the same search as desktop
      const drawerSearch = root.querySelector('.d-header-v2__drawer-search');
      if (drawerSearch && drawer) drawerSearch.addEventListener('click', (e) => { e.preventDefault(); setDrawer(false); openSearch(root); });

      // Drawer dropdowns: one open at a time
      const drawerItems = [...root.querySelectorAll('.d-header-v2__drawer-item--has-dropdown')];
      drawerItems.forEach((item) => {
        const link = item.querySelector('.d-header-v2__drawer-link');
        if (!link) return;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          drawerItems.forEach((other) => { if (other !== item) other.classList.remove('is-open'); });
          item.classList.toggle('is-open');
        });
      });
    };

    const initAll = (scope) => scope.querySelectorAll('[data-d-header-v2]').forEach(initHeaderV2);
    initAll(document);
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-ingredients-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const still = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const slide = (panel, open) => {
      const from = panel.hidden ? 0 : panel.getBoundingClientRect().height;
      panel.getAnimations().forEach((a) => a.cancel());
      panel.hidden = false;
      const to = open ? panel.scrollHeight : 0;
      if (still() || !panel.animate) {
        panel.hidden = !open;
        return;
      }
      const anim = panel.animate(
        [{ height: from + 'px', overflow: 'hidden' }, { height: to + 'px', overflow: 'hidden' }],
        { duration: 300, easing: 'ease' }
      );
      if (!open) anim.onfinish = () => { panel.hidden = true; };
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ingr2-toggle]');
      if (!button) return;
      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (!target) return;
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      const label = button.querySelector('[data-ingr2-label]');
      if (label) label.textContent = open ? button.dataset.labelClose : button.dataset.labelOpen;
      if (button.dataset.ingr2Toggle === 'table') slide(target, open);
      else target.toggleAttribute('data-expanded', open);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-reviews-ugc-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Owner, 31 Oct: no browser controls. The play button starts a video; a tap on a playing video stops it; one plays at
    // a time. While playing, the button stays as a transparent overlay labelled Pause, so a keyboard can stop it too.
    const isUgc = (el) => el && el.matches && el.matches('[data-ugc-video]');
    const pauseOthers = (current) => {
      for (const v of document.querySelectorAll('[data-ugc-video]')) if (v !== current && !v.paused) v.pause();
    };
    document.addEventListener('click', (event) => {
      const media = event.target.closest('[data-ugc-media]');
      const video = media && media.querySelector('[data-ugc-video]');
      if (!video) return;
      if (!video.paused) return video.pause();
      pauseOthers(video); // stop the one playing before this one starts
      const played = video.play();
      if (played && played.catch) played.catch(() => {});
    });
    const show = (video, playing) => {
      const media = video.closest('[data-ugc-media]');
      const button = media && media.querySelector('[data-ugc-play]');
      if (!media) return;
      media.classList.toggle('is-playing', playing);
      if (!button) return;
      if (!button.dataset.playLabel) button.dataset.playLabel = button.getAttribute('aria-label') || 'Play';
      button.setAttribute('aria-label', playing ? 'Pause video' : button.dataset.playLabel);
    };
    document.addEventListener('play', (event) => {
      if (!isUgc(event.target)) return;
      pauseOthers(event.target); // also when something else starts a video
      show(event.target, true);
    }, true);
    for (const type of ['pause', 'ended']) {
      document.addEventListener(type, (event) => { if (isUgc(event.target)) show(event.target, false); }, true);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-rolling-features-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // The track slides by half its width (translateX(-50%)), so each half must cover the ticker or the strip shows its
    // end before the loop restarts. Half = the printed items, repeated (hidden from screen readers) until at least as
    // wide as the ticker; the other half is a hidden copy of it. The speed per item stays the same. Refilled on resize.
    const SECONDS_PER_SET = 40;
    const printed = new WeakMap();
    const fill = (ticker) => {
      const track = ticker.querySelector('.d-ticker__track');
      const group = track && track.firstElementChild;
      if (!group || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!printed.has(group)) printed.set(group, group.innerHTML);
      const items = printed.get(group);
      group.innerHTML = items;
      while (track.children.length > 1) track.lastElementChild.remove();
      const set = group.scrollWidth;
      const sets = set > 0 ? Math.max(1, Math.ceil(ticker.clientWidth / set)) : 1;
      for (let i = 1; i < sets; i++) group.insertAdjacentHTML('beforeend', `<div class="d-ticker__repeat" aria-hidden="true">${items}</div>`);
      const copy = group.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      track.append(copy);
      track.style.animationDuration = `${SECONDS_PER_SET * sets}s`;
    };
    const fillAll = (root) => root.querySelectorAll('[data-ticker]').forEach(fill);
    fillAll(document);
    let width = window.innerWidth;
    let timer;
    window.addEventListener('resize', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (window.innerWidth === width) return;
        width = window.innerWidth;
        fillAll(document);
      }, 200);
    });
    document.addEventListener('shopify:section:load', (event) => fillAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d-usage-v2"] && !Shopify.designMode) return;
  try {
    
  // Clickable steps (d-usage--interactive): a step shows its slide in the stage; videos play only while shown.
  (() => {
    const show = (root, i) => {
      root.querySelectorAll('.d-usage__step').forEach((step, n) => step.setAttribute('aria-pressed', String(n === i)));
      root.querySelectorAll('.d-usage__slide').forEach((slide, n) => {
        slide.hidden = n !== i;
        const video = slide.querySelector('video');
        if (video) n === i ? video.play().catch(() => {}) : video.pause();
      });
    };
    const init = () => document.querySelectorAll('.d-usage--interactive[data-usage]').forEach((root) => show(root, 0));
    document.addEventListener('click', (e) => {
      const step = e.target.closest('.d-usage--interactive .d-usage__step');
      if (!step) return;
      const root = step.closest('[data-usage]');
      show(root, [...root.querySelectorAll('.d-usage__step')].indexOf(step));
    });
    document.addEventListener('shopify:section:load', init);
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d2-bento-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // A swatch shows its colour's image in the main card and, when it has one, swaps the card's style.
    const pickSwatch = (root, btn) => {
      const d = btn.dataset;
      const main = root.querySelector('[data-slot="m"]');
      if (d.img) {
        root.querySelectorAll('.d2-bento__product-img').forEach((img) => {
          img.src = d.img;
          if (d.srcset) img.srcset = d.srcset;
          else img.removeAttribute('srcset');
        });
      }
      if (d.vars) {
        d.vars.split(';').filter(Boolean).forEach((pair) => {
          const [prop, value] = pair.split(':').map((part) => part.trim());
          if (prop === '--card-style') main.dataset.v2Style = value;
          else if (prop && prop !== '--card-dark') main.style.setProperty(prop, value);
        });
        main.toggleAttribute('data-v2-dark', d.vars.includes('--card-dark:1'));
      }
      const group = btn.closest('.d2-bento__swatches');
      group.querySelectorAll('.d2-bento__swatch').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      const label = group.querySelector('.d2-bento__swatch-label');
      if (label) label.textContent = d.label || '';
    };

    // "Cycle through the colours": steps to the next swatch every few seconds until the shopper picks one (or
    // hovers the group); never under reduced motion.
    const initSwatches = (root, state) => {
      root.addEventListener('click', (event) => {
        const btn = event.target.closest('.d2-bento__swatch');
        if (!btn || !root.contains(btn)) return;
        clearInterval(state.cycle);
        pickSwatch(root, btn);
      });
      const group = root.querySelector('.d2-bento__swatches[data-autoplay]');
      if (!group || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const buttons = [...group.querySelectorAll('.d2-bento__swatch')];
      if (buttons.length < 2) return;
      // one round through the colours, back to the first, then it rests
      state.cycle = setInterval(() => {
        const at = buttons.findIndex((b) => b.getAttribute('aria-pressed') === 'true');
        const next = (at + 1) % buttons.length;
        pickSwatch(root, buttons[next]);
        if (next === 0) clearInterval(state.cycle);
      }, (Number(group.dataset.autoplay) || 3) * 1000);
      ['pointerenter', 'focusin'].forEach((e) => group.addEventListener(e, () => clearInterval(state.cycle), { once: true }));
    };

    // Rotating cards: each slide stays its seconds, then crossfades to the next; paused while hovered or focused; one
    // round, then it rests. The dots show which one and jump to theirs. Under reduced motion nothing moves by itself.
    const FADE = 800;
    // Reviews shown 2-3 at once need room: 3 side by side from 560px, 2 stacked from 260px. In a smaller card the sets
    // become one review per slide (dots rebuilt), so no layout ever has to change shape for them.
    const splitReviews = (rotator) => {
      const set = rotator.querySelector('.d2-bento__review-set');
      const per = Number(set?.dataset.per || 1);
      const w = rotator.clientWidth;
      if (per < 2 || w >= 560 || (per === 2 && w >= 260)) return;
      const reviews = [...rotator.querySelectorAll('.d-ugc__card')];
      rotator.replaceChildren(...reviews.map((review, i) => {
        const slide = document.createElement('div');
        slide.className = 'd2-bento__slide d2-bento__review-set';
        slide.dataset.per = '1';
        slide.hidden = i > 0;
        slide.append(review);
        return slide;
      }));
      const card = rotator.closest('.d2-bento__card');
      let dots = card.querySelector('.d2-bento__dots');
      if (!dots) {
        dots = document.createElement('div');
        dots.className = 'd2-bento__dots';
        card.append(dots);
      }
      dots.replaceChildren(...reviews.map((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Review ${i + 1} / ${reviews.length}`);
        dot.setAttribute('aria-current', String(i === 0));
        return dot;
      }));
    };
    const initRotators = (root, state) => {
      const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      state.rotators = [];
      root.querySelectorAll('.d2-bento__rotator[data-rotate]').forEach((rotator) => {
        splitReviews(rotator);
        const slides = [...rotator.querySelectorAll(':scope > .d2-bento__slide')];
        if (slides.length < 2) return;
        const card = rotator.closest('.d2-bento__card');
        const dots = [...card.querySelectorAll('.d2-bento__dots button')];
        let at = 0;
        let paused = false;
        let leaving;
        const show = (next) => {
          const prev = slides[at];
          at = next;
          dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === next)));
          clearTimeout(leaving);
          slides.forEach((slide, i) => {
            slide.hidden = i !== next;
            if (slide !== prev) delete slide.dataset.leaving;
            delete slide.dataset.entering;
          });
          if (still) return;
          // the last slide stays on screen while it fades out (hidden for screen readers already)
          prev.dataset.leaving = '';
          slides[next].dataset.entering = '';
          leaving = setTimeout(() => {
            delete prev.dataset.leaving;
            delete slides[next].dataset.entering;
          }, FADE);
        };
        dots.forEach((dot, i) => dot.addEventListener('click', () => { if (i !== at) show(i); }));
        ['pointerenter', 'focusin'].forEach((e) => card.addEventListener(e, () => { paused = true; }));
        ['pointerleave', 'focusout'].forEach((e) => card.addEventListener(e, () => { paused = false; }));
        if (still) return;
        rotator.dataset.rotating = '';
        // One full round, back to the first slide, then it rests (moving content stops by itself); the dots still work
        const timer = setInterval(() => {
          if (paused) return;
          show((at + 1) % slides.length);
          if (at === 0) clearInterval(timer);
        }, (Number(rotator.dataset.rotate) || 4) * 1000);
        state.rotators.push(timer);
      });
    };

    const pad = (n) => String(n).padStart(2, '0');

    // Ticks every countdown in the section once a second. An end date that doesn't parse hides the
    // countdown; at zero it shows the ended text (or hides). The card itself always stays.
    const initCountdowns = (root, state) => {
      const els = [...root.querySelectorAll('.d2-bento__countdown')];
      if (!els.length) return;
      const tick = () => {
        els.forEach((el) => {
          if (el.dataset.done) return;
          const end = Date.parse(el.dataset.end || '');
          if (!Number.isFinite(end)) {
            el.dataset.done = '1';
            el.hidden = true;
            return;
          }
          const left = Math.max(0, Math.floor((end - Date.now()) / 1000));
          if (left === 0) {
            el.dataset.done = '1';
            if (el.dataset.endedText) {
              el.textContent = el.dataset.endedText;
              el.classList.add('is-ended');
            } else {
              el.hidden = true;
            }
            return;
          }
          const parts = { d: Math.floor(left / 86400), h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
          el.querySelectorAll('[data-unit]').forEach((b) => { b.textContent = pad(parts[b.dataset.unit]); });
        });
      };
      tick();
      state.interval = setInterval(tick, 1000);
    };

    // Muted loop while on screen. Under reduced motion nothing autoplays; the play button (shown by
    // CSS) starts and stops the video instead.
    const initVideos = (root, state) => {
      const videos = [...root.querySelectorAll('.d2-bento__video')];
      videos.forEach((video) => {
        const btn = video.parentElement.querySelector('.d2-bento__play');
        if (btn) {
          btn.addEventListener('click', () => {
            if (video.paused) video.play();
            else video.pause();
          });
        }
      });
      if (!videos.length || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      state.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const played = entry.target.play();
            if (played && played.catch) played.catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.25 });
      videos.forEach((video) => state.observer.observe(video));
    };

    const states = new WeakMap();

    // Campaign strip: the track slides by half its width, so each half needs at least the strip's width of copy, or the
    // end of every loop is empty and the text pops back in. Short copy is repeated to fill a half (again on resize and
    // once the fonts are in); the duration grows with the copies, so the speed stays the same.
    const fillMarquee = (marquee) => {
      const track = marquee.querySelector('.d2-bento__marquee-track');
      const one = track && track.querySelector('.d2-bento__marquee-text');
      const w = one ? one.getBoundingClientRect().width : 0;
      if (!w) return;
      const per = Math.max(1, Math.ceil(marquee.clientWidth / w));
      if (track.children.length === per * 2) return;
      track.replaceChildren(one, ...Array.from({ length: per * 2 - 1 }, () => {
        const copy = one.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        return copy;
      }));
      track.style.setProperty('--copies', per);
    };
    const initMarquees = (root, state) => {
      const marquees = [...root.querySelectorAll('.d2-bento__marquee:not([data-marquee="false"])')];
      if (!marquees.length) return;
      const fill = () => marquees.forEach(fillMarquee);
      fill();
      if (document.fonts) document.fonts.ready.then(fill);
      state.marquees = new ResizeObserver(fill);
      marquees.forEach((m) => state.marquees.observe(m));
    };

    const init = (root) => {
      if (root.dataset.bentoReady) return;
      root.dataset.bentoReady = '1';
      const state = {};
      states.set(root, state);
      initSwatches(root, state);
      initRotators(root, state);
      initCountdowns(root, state);
      initVideos(root, state);
      initMarquees(root, state);
    };

    const teardown = (root) => {
      const state = states.get(root);
      if (state) {
        clearInterval(state.interval);
        clearInterval(state.cycle);
        (state.rotators || []).forEach(clearInterval);
        if (state.observer) state.observer.disconnect();
        if (state.marquees) state.marquees.disconnect();
        states.delete(root);
      }
    };

    const within = (target) => (target.matches && target.matches('.d2-bento') ? [target] : [...target.querySelectorAll('.d2-bento')]);

    document.querySelectorAll('.d2-bento').forEach(init);
    document.addEventListener('shopify:section:load', (event) => within(event.target).forEach(init));
    document.addEventListener('shopify:section:unload', (event) => within(event.target).forEach(teardown));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.jv-mobile-menu')) {
      // when <a> with hreh = "/collections/all" within "header__inline-menu" is clicked then prevent default and open drawer menu!
      document.querySelectorAll('.header__inline-menu a[href="/collections/all"]').forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          document.querySelector('[aria-controls="menu-drawer"]').click();
        });
      });

      document.querySelector("#HeaderMenu-all-products").addEventListener('click', function (event) {
        event.preventDefault();
        document.querySelector('[aria-controls="menu-drawer"]').click();
      });
    }
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["l-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('.l-tabs__tab');
    const tabPanels = document.querySelectorAll('.l-tabs__panel');

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        // Remove active class from all tabs and panels
        tabButtons.forEach((btn) => btn.classList.remove('is-active'));
        tabPanels.forEach((panel) => panel.classList.remove('is-active'));

        // Add active class to clicked tab and corresponding panel
        button.classList.add('is-active');
        const panelId = button.getAttribute('aria-controls');
        document.getElementById(panelId).classList.add('is-active');

        // Update aria-selected
        tabButtons.forEach((btn) => btn.setAttribute('aria-selected', 'false'));
        button.setAttribute('aria-selected', 'true');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');

    const init = (root) => {
      if (root.dataset.lpAnnouncementReady) return;
      root.dataset.lpAnnouncementReady = '1';

      const countdown = root.querySelector('[data-countdown-end]');
      if (!countdown) return;
      const end = new Date(countdown.dataset.countdownEnd).getTime();
      if (Number.isNaN(end)) return;

      const hours = countdown.querySelector('[data-hours]');
      const minutes = countdown.querySelector('[data-minutes]');
      const seconds = countdown.querySelector('[data-seconds]');

      const tick = () => {
        const left = end - Date.now();
        // A real deadline: once it passes, the countdown goes away rather than restarting.
        if (left <= 0) {
          countdown.hidden = true;
          clearInterval(timer);
          return;
        }
        countdown.hidden = false;
        hours.textContent = pad(Math.floor(left / 3600000));
        minutes.textContent = pad(Math.floor((left % 3600000) / 60000));
        seconds.textContent = pad(Math.floor((left % 60000) / 1000));
      };

      const timer = setInterval(tick, 1000);
      tick();
    };

    const initAll = (scope = document) => scope.querySelectorAll('.lp-announcement').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-benefits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    for (const root of document.querySelectorAll('.lp-benefits')) {
      const track = root.querySelector('[data-slider-track]');
      const cards = [...root.querySelectorAll('[data-slider-card]')];
      const dots = [...root.querySelectorAll('[data-slider-dot]')];
      if (!track || !cards.length) continue;

      const setActive = (index) => {
        for (const [i, dot] of dots.entries()) {
          dot.classList.toggle('is-active', i === index);
        }
      };

      const closestIndex = () => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let best = 0;
        let bestDistance = Infinity;
        for (const [i, card] of cards.entries()) {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const distance = Math.abs(cardCenter - center);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        }
        return best;
      };

      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          setActive(closestIndex());
          ticking = false;
        });
      });

      for (const [i, dot] of dots.entries()) {
        dot.addEventListener('click', () => {
          const card = cards[i];
          if (!card) return;
          const target = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
          track.scrollTo({ left: target, behavior: 'smooth' });
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAll(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('[data-lp-form]');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
  }

  function initForm(form) {
    if (form.dataset.lpBound === 'true') return;
    form.dataset.lpBound = 'true';
    form.dataset.renderedAt = String(Date.now());
    form.addEventListener('submit', onSubmit);
  }

  function errorBoxFor(field) {
    var id = field.getAttribute('aria-describedby');
    if (!id) return null;
    return document.getElementById(id);
  }

  // `scope` is the whole form on a single-step form, and the visible
  // [data-lp-step] wrapper on a two-step one.
  function clearErrors(scope) {
    var fields = scope.querySelectorAll('[data-lp-field]');
    for (var i = 0; i < fields.length; i++) {
      fields[i].removeAttribute('aria-invalid');
      var box = errorBoxFor(fields[i]);
      if (box) { box.textContent = ''; box.hidden = true; }
    }
    var status = scope.querySelector('[data-lp-status]');
    if (status) status.textContent = '';
  }

  function fieldError(form, el) {
    if (el.type === 'checkbox') {
      if (el.required && !el.checked) return form.dataset.msgRequired || '';
      return null;
    }
    var v = el.validity;
    if (v.valueMissing) return form.dataset.msgRequired || '';
    if (v.typeMismatch && el.type === 'email') return form.dataset.msgEmail || '';
    return null;
  }

  function validate(form, scope) {
    var first = null;
    var fields = scope.querySelectorAll('[data-lp-field]');
    for (var i = 0; i < fields.length; i++) {
      var msg = fieldError(form, fields[i]);
      if (msg === null) continue;
      fields[i].setAttribute('aria-invalid', 'true');
      var box = errorBoxFor(fields[i]);
      if (box) { box.textContent = msg; box.hidden = false; }
      if (!first) first = fields[i];
    }
    if (first) { first.focus(); return false; }
    return true;
  }

  function buildPayload(form) {
    var data = {};
    var fields = form.querySelectorAll('[data-lp-field]');
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];
      if (!el.name) continue;
      if (el.type === 'radio') {
        if (el.checked) data[el.name] = el.value;
        else if (!(el.name in data)) data[el.name] = '';
      } else if (el.type === 'checkbox') {
        data[el.name] = el.checked;
      } else {
        data[el.name] = el.value.trim();
      }
    }
    var hidden = form.querySelectorAll('[data-lp-hidden]');
    for (var j = 0; j < hidden.length; j++) {
      if (hidden[j].name) data[hidden[j].name] = hidden[j].value;
    }
    var cw = form.querySelector('[data-lp-consent]');
    data.consent_text = cw && cw.dataset.consentText ? cw.dataset.consentText : '';
    data.submitted_at = new Date().toISOString();
    data.page_url = window.location.href;
    data.locale = form.dataset.locale || '';
    data.source = form.dataset.source || '';
    return data;
  }

  function setBusy(scope, busy) {
    var btn = scope.querySelector('[data-lp-submit]');
    if (!btn) return;
    btn.disabled = busy;
    btn.textContent = busy ? btn.dataset.busy : btn.dataset.idle;
  }

  function showSuccess(form) {
    var box = form.parentNode.querySelector('[data-lp-success]');
    if (!box) return;
    form.hidden = true;
    box.hidden = false;
    var h = box.querySelector('[data-lp-success-heading]');
    if (h) h.focus();
  }

  function showError(form, scope, err) {
    if (err) console.error(err);
    var status = scope.querySelector('[data-lp-status]');
    if (status) status.textContent = form.dataset.msgError;
  }

  function namedFieldValue(form, name) {
    var el = form.querySelector('[data-lp-field][name="' + name + '"]');
    return el ? el.value.trim() : '';
  }

  function namedHiddenValue(form, name) {
    var el = form.querySelector('[data-lp-hidden][name="' + name + '"]');
    return el ? el.value.trim() : '';
  }

  function trackLead(form) {
    if (form.dataset.metaLead !== 'true') return;
    // Not calling window.fbq directly on purpose. It is undefined at page load
    // and while consent is pending, and only becomes a function once the
    // Facebook channel's app pixel loads into the main page - so a submit can
    // land before it exists, and a `typeof window.fbq` guard would drop that
    // lead silently. Publishing onto Shopify's event bus is deterministic: the
    // custom pixel in 06-event-tracking/meta-events-pixel.js subscribes to
    // this name and calls fbq inside the sandbox. Email and phone ride along
    // because the sandbox cannot read the form's fields itself, and hashed
    // email/phone is the only match signal this setup has. page_url rides
    // along because both Meta's `dl` and GA4's page_location report the
    // sandbox iframe's URL, not the page.
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    analytics.publish('lp_form_lead', {
      source: form.dataset.source || '',
      email: namedFieldValue(form, 'email'),
      phone: namedFieldValue(form, 'phone'),
      // page_url, not page_path: every publisher on this bus sends the same
      // key, and the quiz sends Liquid's canonical_url. Origin plus pathname,
      // no query string, so Klaviyo tokens and discount codes reach neither
      // Meta nor GA4.
      page_url: window.location.origin + window.location.pathname,
      // A Hidden field block named `campaign` - the same one the webhook
      // payload already carries, rather than a second mechanism for it.
      // source distinguishes WHICH form; campaign distinguishes which push,
      // so several landers on one campaign stay comparable.
      campaign: namedHiddenValue(form, 'campaign')
    });
  }

  function isBot(form) {
    var hp = form.querySelector('[data-lp-hp]');
    if (hp && hp.value.trim() !== '') return true;

    var floor = Number(form.dataset.minSeconds);
    if (!floor) return false;

    var rendered = Number(form.dataset.renderedAt);
    if (!rendered) return false;

    return (Date.now() - rendered) / 1000 < floor;
  }

  function hasWebhook(form) {
    return /^https?:\/\//i.test(form.dataset.webhook || '');
  }

  function post(form, scope, payload, onSent) {
    var controller = new AbortController();
    var timeout = Number(form.dataset.timeout) || 15000;
    var timer = setTimeout(function () { controller.abort(); }, timeout);

    setBusy(scope, true);

    function clear() { clearTimeout(timer); }

    fetch(form.dataset.webhook, {
      method: 'POST',
      // text/plain keeps this a CORS 'simple request'. application/json
      // triggers a preflight OPTIONS, which Google Apps Script web apps do
      // not answer - the POST then fails before it is ever sent.
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      signal: controller.signal
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res;
      })
      .then(function () {
        onSent();
      }, function (err) {
        showError(form, scope, err);
        setBusy(scope, false);
      })
      .then(clear, clear);
  }

  function newLeadId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function showStep(form, step) {
    var steps = form.querySelectorAll('[data-lp-step]');
    for (var i = 0; i < steps.length; i++) steps[i].hidden = steps[i].dataset.lpStep !== step;
    var scope = form.querySelector('[data-lp-step="' + step + '"]');
    if (!scope) return;
    var target = scope.querySelector('[data-lp-step-heading]') || scope.querySelector('[data-lp-field]');
    if (target) target.focus();
  }

  function onSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    if (form.dataset.lpSteps === '2') { onStepSubmit(form); return; }

    clearErrors(form);
    // Validate BEFORE the bot check. The other order meant a visitor who clicked
    // Send within the timing floor was shown "Thank you." on a completely empty
    // form - showSuccess() ran without validating anything or sending anything.
    // A bot that fills the form correctly still gets the silent fake success.
    if (!validate(form, form)) return;
    if (isBot(form)) { showSuccess(form); return; }

    if (!hasWebhook(form)) { showError(form, form); return; }

    // Fires on the click, so a webhook outage does not lose the ad signal.
    // Still after validate() and isBot(): an empty click is not a lead, and the
    // bot paths never send one.
    trackLead(form);

    post(form, form, buildPayload(form), function () { showSuccess(form); });
  }

  // Two-step forms send the lead before asking about quantity and price, so a
  // visitor who stops at step 2 is still a lead sales can call. Both POSTs
  // carry one lead_id, which joins the two rows downstream.
  function onStepSubmit(form) {
    var scope = form.querySelector('[data-lp-step]:not([hidden])');
    if (!scope) return;
    var first = scope.dataset.lpStep === '1';

    clearErrors(scope);
    if (!validate(form, scope)) return;
    // The bot checks guard lead capture. Step 2 is only reachable after a real
    // step-1 POST, so it is not checked again.
    if (first && isBot(form)) { showSuccess(form); return; }
    if (!hasWebhook(form)) { showError(form, scope); return; }

    if (first && !form.dataset.leadId) {
      // Minted once and kept across retries: a timed-out POST may still have
      // landed, and a retry must not look like a second lead - either to the
      // payload's lead_id or to the ad platform, so trackLead only runs on
      // the attempt that mints the id.
      form.dataset.leadId = newLeadId();
      trackLead(form);
    }

    var payload = buildPayload(form);
    payload.lead_id = form.dataset.leadId;
    payload.step = first ? 'contact' : 'package';

    post(form, scope, payload, function () {
      if (first) showStep(form, '2');
      else showSuccess(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');

    const fillSummary = async (summary) => {
      const { appKey, productId, countLabel = '' } = summary.dataset;
      try {
        const response = await fetch(
          `https://api.yotpo.com/v1/widget/${encodeURIComponent(appKey)}/products/${encodeURIComponent(productId || 'yotpo_site_reviews')}/reviews.json?per_page=1`
        );
        const bottomline = (await response.json())?.response?.bottomline;
        if (!bottomline) return;

        const average = Number(bottomline.average_score) || 0;
        const total = Number(bottomline.total_review) || 0;
        const distribution = bottomline.star_distribution || {};

        summary.querySelector('[data-summary-average]').textContent = average.toFixed(1);
        summary.querySelector('[data-summary-total]').textContent = countLabel.replace('[count]', total);

        const rounded = Math.round(average);
        summary.querySelectorAll('[data-summary-stars] .lp-reviews__star').forEach((star, i) => {
          star.classList.toggle('lp-reviews__star--empty', i >= rounded);
        });

        for (let level = 1; level <= 5; level++) {
          const count = Number(distribution[level] ?? 0);
          const countEl = summary.querySelector(`[data-star-count="${level}"]`);
          if (countEl) countEl.textContent = count;
          const fillEl = summary.querySelector(`[data-star-fill="${level}"]`);
          if (fillEl) fillEl.style.width = `${Math.max(total ? Math.round((count / total) * 100) : 0, 2)}%`;
        }
      } catch {
        // Keep the "–" placeholders.
      }
    };

    const init = (root) => {
      // The theme editor re-renders a section and fires shopify:section:load, so
      // init runs again on the new markup; the flag stops a double init.
      if (root.dataset.lpReviewsReady) return;
      root.dataset.lpReviewsReady = '1';
      root.classList.add('lp-reviews--js');

      const grid = root.querySelector('[data-reviews-grid]');
      const cards = [...root.querySelectorAll('[data-review-card]')];
      const button = root.querySelector('[data-reviews-more]');
      const label = button?.querySelector('[data-reviews-more-label]');
      let expanded = false;

      const limit = () => {
        const n = parseInt(grid?.dataset[mobile.matches ? 'mobileCount' : 'desktopCount'], 10);
        return n > 0 ? n : cards.length;
      };

      const render = () => {
        const base = limit();
        const shown = expanded ? cards.length : base;
        cards.forEach((card, i) => { card.hidden = i >= shown; });
        if (!button) return;
        button.parentElement.hidden = cards.length <= base;
        button.setAttribute('aria-expanded', String(expanded));
        if (label) label.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
      };

      button?.addEventListener('click', () => {
        expanded = !expanded;
        render();
        if (!expanded) grid?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      root.addEventListener('lp-reviews:expand', () => {
        expanded = true;
        render();
      });

      mobile.addEventListener('change', render);
      render();

      const summary = root.querySelector('[data-reviews-summary]');
      if (summary?.dataset.appKey) fillSummary(summary);
    };

    const initAll = (scope = document) => scope.querySelectorAll('.lp-reviews').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));

    // Theme editor: selecting a review that Load more has hidden expands its section.
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest?.('[data-review-card]');
      if (card?.hidden) card.closest('.lp-reviews')?.dispatchEvent(new CustomEvent('lp-reviews:expand'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-stats"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    for (const root of document.querySelectorAll('.lp-stats')) {
      const track = root.querySelector('[data-slider-track]');
      const cards = [...root.querySelectorAll('[data-slider-card]')];
      const dots = [...root.querySelectorAll('[data-slider-dot]')];
      if (!track || !cards.length) continue;

      const setActive = (index) => {
        for (const [i, dot] of dots.entries()) {
          dot.classList.toggle('is-active', i === index);
        }
      };

      const closestIndex = () => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let best = 0;
        let bestDistance = Infinity;
        for (const [i, card] of cards.entries()) {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const distance = Math.abs(cardCenter - center);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        }
        return best;
      };

      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          setActive(closestIndex());
          ticking = false;
        });
      });

      for (const [i, dot] of dots.entries()) {
        dot.addEventListener('click', () => {
          const card = cards[i];
          if (!card) return;
          const target = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
          track.scrollTo({ left: target, behavior: 'smooth' });
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-sticky"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sticky = document.querySelector('.lp-sticky');
    if (!sticky) return;

    const scrollTarget = sticky.dataset.scrollTarget;
    const hideSelectors = (sticky.dataset.hideSelectors || '')
      .split(',')
      .map((selector) => selector.trim())
      .filter(Boolean);
    const revealDelay = Number(sticky.dataset.revealDelay) || 0;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
    };

    let lastState = null;
    let isInitialized = false;

    // A page can carry two copies of the same target: an A/B test renders both
    // the control and the variation and hides one with display:none. A plain
    // document.querySelector returns the first in DOM order, which may be the
    // hidden one -- the sticky bar would then scroll to an invisible buy box
    // and never hide itself, since a display:none element never intersects.
    // getClientRects() is empty exactly when the element generates no boxes.
    const findRendered = (selector) => {
      const els = document.querySelectorAll(selector);
      for (const el of els) {
        if (el.getClientRects().length) return el;
      }
      return els[0] || null;
    };

    const checkVisibility = () => {
      const isAnyVisible = hideSelectors.some((selector) => {
        const el = findRendered(selector);
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });

      if (lastState === isAnyVisible) return;
      lastState = isAnyVisible;

      if (!isInitialized) {
        isInitialized = true;
        if (!isAnyVisible) sticky.classList.remove('hidden');
        return;
      }

      sticky.classList.toggle('hidden', isAnyVisible);
    };

    const observer = new IntersectionObserver(checkVisibility, observerOptions);
    for (const selector of hideSelectors) {
      // Every match, not just the first: with an A/B duplicate on the page the
      // visible copy can change after this runs.
      for (const el of document.querySelectorAll(selector)) observer.observe(el);
    }

    let scrollFrame;
    window.addEventListener(
      'scroll',
      () => {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(checkVisibility);
      },
      { passive: true }
    );

    setTimeout(checkVisibility, 50);
    setTimeout(() => sticky.classList.add('is-ready'), revealDelay);

    const scrollButton = sticky.querySelector('.lp-sticky__button--scroll');
    if (scrollButton && scrollTarget) {
      scrollButton.addEventListener('click', () => {
        findRendered(scrollTarget)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    for (const root of document.querySelectorAll('.lp-testimonials')) {
      const track = root.querySelector('[data-slider-track]');
      const cards = [...root.querySelectorAll('[data-slider-card]')];
      const dots = [...root.querySelectorAll('[data-slider-dot]')];
      if (!track || !cards.length) continue;

      const setActive = (index) => {
        for (const [i, dot] of dots.entries()) {
          dot.classList.toggle('is-active', i === index);
        }
      };

      const closestIndex = () => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let best = 0;
        let bestDistance = Infinity;
        for (const [i, card] of cards.entries()) {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const distance = Math.abs(cardCenter - center);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        }
        return best;
      };

      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          setActive(closestIndex());
          ticking = false;
        });
      });

      for (const [i, dot] of dots.entries()) {
        dot.addEventListener('click', () => {
          const card = cards[i];
          if (!card) return;
          const target = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
          track.scrollTo({ left: target, behavior: 'smooth' });
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p-environment"] && !Shopify.designMode) return;
  try {
    
  // Add any JavaScript functionality here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.p-faq-item');

    faqItems.forEach((item) => {
      const question = item.querySelector('.p-faq-question');

      question.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        // Close all items
        faqItems.forEach((faqItem) => {
          faqItem.classList.remove('active');
        });

        // If the clicked item wasn't active, open it
        if (!isActive) {
          item.classList.add('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p-main-cta"] && !Shopify.designMode) return;
  try {
    
  // Add any JavaScript functionality here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const businessId = '{{ section.settings.trustpilot_business_id }}';
    const apiKey = '{{ section.settings.trustpilot_api_key }}';
    const reviewsCount = '{{ section.settings.reviews_count }}';

    if (!businessId || !apiKey) {
      const reviewsGrid = document.querySelector('.p-reviews-grid');
      reviewsGrid.innerHTML =
        '<div class="p-reviews-loading">Please configure your Trustpilot Business ID and API Key in the section settings.</div>';
      return;
    }

    // For demo purposes, we'll use mock data
    // In production, you would use the actual Trustpilot API
    //fetchTrustpilotReviews(businessId, apiKey, reviewsCount);
  });

  function fetchTrustpilotReviews(businessId, apiKey, count) {
    // In a real implementation, you would make an API call to Trustpilot
    // For example:
    // const url = `https://api.trustpilot.com/v1/business-units/${businessId}/reviews?apiKey=${apiKey}&perPage=${count}`;
    // fetch(url)...

    // For demo purposes, we'll use mock data
    setTimeout(() => {
      const mockReviews = [
        {
          name: 'Denis',
          verified: true,
          stars: 5,
          text: 'Fresh 32! Ščetke so prišle! Definitivno boljše od Curaproxa, zanimive na prvi pogled, mehke š četine, res vrhunsko ste se odrezali z vašim projektom! Podpiram slovensko!',
        },
        {
          name: 'Nina',
          verified: true,
          stars: 4,
          text: 'Fresh 32! Ščetke so prišle! Definitivno boljše od Curaproxa, zanimive na prvi pogled, mehke š četine, res vrhunsko ste se odrezali z vašim projektom! Podpiram slovensko!',
        },
        {
          name: 'Fran',
          verified: true,
          stars: 4.5,
          text: 'Fresh 32! Ščetke so prišle! Definitivno boljše od Curaproxa, zanimive na prvi pogled, mehke š četine, res vrhunsko ste se odrezali z vašim projektom! Podpiram slovensko!',
        },
        {
          name: 'Ana',
          verified: true,
          stars: 4,
          text: 'Fresh 32! Ščetke so prišle! Definitivno boljše od Curaproxa, zanimive na prvi pogled, mehke š četine, res vrhunsko ste se odrezali z vašim projektom! Podpiram slovensko!',
        },
        {
          name: 'Laura',
          verified: true,
          stars: 5,
          text: 'Fresh 32! Ščetke so prišle! Definitivno boljše od Curaproxa, zanimive na prvi pogled, mehke š četine, res vrhunsko ste se odrezali z vašim projektom! Podpiram slovensko!',
        },
        {
          name: 'Mark',
          verified: true,
          stars: 4,
          text: 'Fresh 32! Ščetke so prišle! Definitivno boljše od Curaproxa, zanimive na prvi pogled, mehke š četine, res vrhunsko ste se odrezali z vašim projektom! Podpiram slovensko!',
        },
      ];

      renderReviews(mockReviews);
      document.getElementById('reviews-total-count').textContent = '5020';
    }, 500);
  }

  function renderReviews(reviews) {
    const reviewsGrid = document.querySelector('.p-reviews-grid');
    const verifiedSvg = document.querySelector('#verified-svg-template').innerHTML;
    const trustpilotLogoSvg = document.querySelector('#trustpilot-logo-svg-template').innerHTML;
    reviewsGrid.innerHTML = '';

    reviews.forEach((review) => {
      const card = document.createElement('div');
      card.className = 'p-reviews-card';

      const starsHtml = `
      <img 
      src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-${review.stars}.svg" 
      alt="${review.stars} stars"
      width="100"
      height="20"
    >
      ${trustpilotLogoSvg}
    `;

      card.innerHTML = `
      <div class="p-reviews-card-header">
        <h2 class="p-reviews-card-name">${review.name}</h2>
        <div class="p-reviews-card-verified">
          ${verifiedSvg}
          Verified
        </div>
      </div>
      ${starsHtml}
      <div class="p-reviews-card-text">${review.text}</div>
    `;

      reviewsGrid.appendChild(card);
    });
  }

  function generateStarsImage(stars) {
    // In a real implementation, you might want to use actual Trustpilot star images
    // For now, we'll use a simple representation
    const fullStars = Math.floor(stars);
    const halfStar = stars % 1 >= 0.5;

    let starsHtml = '';
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        starsHtml += '<span style="color: #00B67A;">★</span>';
      } else if (i === fullStars && halfStar) {
        starsHtml += '<span style="color: #00B67A;">★</span>';
      } else {
        starsHtml += '<span style="color: #DCDCE6;">★</span>';
      }
    }

    return starsHtml;
  }

  } catch(e) { console.error(e); }
})();
})();
